import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useMemo } from 'react';
import RollingDatePointConfig from '../../filterQueryFormat/rollingDates/RollingDatePointConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueRollingDatePoint = props => {
  const {
    value
  } = props;
  const i18nToken = useMemo(() => value ? RollingDatePointConfig.toRollingDatePointOptionValue(value) : undefined, [value]);
  return i18nToken ? /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `customerDataFiltersUI.customerDataFilters.RollingDatePoints.options.text.${i18nToken}`
    })
  }) : null;
};
export default DisplayValueRollingDatePoint;